class CompareList extends HTMLElement {
  constructor() {
    super();

    this.sliderComponent = this.querySelector('slider-component');

    this.slider = this.querySelector('.grid');

    this.moreLink = this.dataset.moreLink;

    this.fetchProducts();
  }

  fetchProducts() {
    const compareProducts = JSON.parse(
      localStorage.getItem('compare-products') || '[]'
    );

    if (compareProducts.length == 0) {
      return;
    } else {
      this.slider.innerHTML = '';

      var promises = [];

      compareProducts.forEach((productHandle) => {
        promises.push(
          new Promise((resolve, reject) => {
            fetch(`/products/${productHandle}?section_id=compare_item`)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(
                  responseText,
                  'text/html'
                );
                const item = html.querySelector('.compare-item');

                if (item) {
                  this.slider.appendChild(item);

                  resolve();

                  const remove = item.querySelector('.compare-product__remove');

                  if (remove) {
                    remove.addEventListener('click', (event) => {
                      event.preventDefault();
                      const compareProducts = JSON.parse(
                        localStorage.getItem('compare-products') || '[]'
                      );

                      const index = compareProducts.indexOf(productHandle);
                      if (index > -1) {
                        compareProducts.splice(index, 1);
                        localStorage.setItem(
                          'compare-products',
                          JSON.stringify(compareProducts)
                        );
                      }

                      item.remove();
                    });
                  }
                }
              });
          })
        );
      });

      Promise.all(promises).then(() => {
        var tallestDescription = 0;
        const descriptions = this.slider.querySelectorAll(
          '.compare-product__row--description'
        );
        descriptions.forEach((description) => {
          if (description.offsetHeight > tallestDescription) {
            tallestDescription = description.offsetHeight;
          }
        });
        descriptions.forEach((description) => {
          description.style.height = `${tallestDescription}px`;
        });

        var tallestTitle = 0;
        const titles = this.slider.querySelectorAll('.compare-product__title');
        titles.forEach((title) => {
          if (title.offsetHeight > tallestTitle) {
            tallestTitle = title.offsetHeight;
          }
        });
        titles.forEach((title) => {
          title.style.height = `${tallestTitle}px`;
        });

        if (compareProducts.length < 8 && this.moreLink) {
          const li = document.createElement('li');
          li.classList.add('compare-item', 'grid__item', 'slider__slide');
          li.id = `Slide-Compare-X`;

          const div = document.createElement('div');
          div.classList.add('compare-product');

          const images = document.createElement('div');
          images.classList.add('compare-item__images');

          const media = document.createElement('div');
          media.classList.add('media', 'media--square');

          const link = document.createElement('a');
          link.href = this.moreLink;
          link.classList.add('compare-product__link', 'link');
          link.textContent = 'Select another product';

          media.appendChild(link);
          images.appendChild(media);
          div.appendChild(images);
          li.appendChild(div);
          this.slider.appendChild(li);
        }

        this.sliderComponent.build();
      });
    }
  }
}

customElements.define('compare-list', CompareList);

class CompareSlider extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('.compare-item__images');
    this.images = this.querySelectorAll('.compare-product__image');

    this.prevButton = this.parentElement.querySelector(
      '.compare-item__slider-button--prev'
    );
    this.nextButton = this.parentElement.querySelector(
      '.compare-item__slider-button--next'
    );

    if (this.prevButton) {
      this.prevButton.addEventListener('click', this.handlePrev.bind(this));
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', this.handleNext.bind(this));
    }
  }

  handlePrev() {
    const activeImage = this.querySelector('.compare-product__image--active');
    const prevImage = activeImage.previousElementSibling;

    if (prevImage) {
      this.container.scrollLeft -= prevImage.offsetWidth;

      prevImage.classList.add('compare-product__image--active');
      activeImage.classList.remove('compare-product__image--active');

      this.nextButton.removeAttribute('disabled');
    }

    if (prevImage === this.images[0]) {
      this.prevButton.setAttribute('disabled', true);
    }
  }

  handleNext() {
    const activeImage = this.querySelector('.compare-product__image--active');
    const nextImage = activeImage.nextElementSibling;

    if (nextImage) {
      this.container.scrollLeft += nextImage.offsetWidth;

      nextImage.classList.add('compare-product__image--active');
      activeImage.classList.remove('compare-product__image--active');

      this.prevButton.removeAttribute('disabled');
    }

    if (nextImage === this.images[this.images.length - 1]) {
      this.nextButton.setAttribute('disabled', true);
    }
  }
}

customElements.define('compare-slider', CompareSlider);

class CompareWidget extends HTMLElement {
  constructor() {
    super();

    this.body = this.querySelector('.compare-widget__body');

    this.clearButton = this.querySelector('.compare-widget__clear');

    this.clearButton.addEventListener('click', this.clear.bind(this));

    this.update();
  }

  clear() {
    localStorage.removeItem('compare-products');
    this.update();
  }

  update() {
    const compareProducts = JSON.parse(
      localStorage.getItem('compare-products') || '[]'
    );

    if (compareProducts.length == 0) {
      this.hide();
    } else {
      this.show();
    }
  }

  hide() {
    this.body.innerHTML = '';
    this.setAttribute('aria-hidden', true);
  }

  show() {
    this.fetchProducts();
  }

  remove(event) {
    event.preventDefault();

    const productHandle = event.target.dataset.productHandle;
    const card = event.target.closest('.compare-card');
    const compareProducts = JSON.parse(localStorage.getItem('compare-products') || '[]');    
    const index = compareProducts.indexOf(productHandle);

    if (index > -1) {
      compareProducts.splice(index, 1);
      localStorage.setItem('compare-products', JSON.stringify(compareProducts));
    }

    card.remove();

    if (compareProducts.length == 0) {
      this.hide();
    }

    document.querySelectorAll(`compare-add[data-product-handle='${productHandle}']`).forEach((add) => {
      add.querySelector('input[type="checkbox"]').checked = false;
    });
  }

  fetchProducts() {
    const compareProducts = JSON.parse(
      localStorage.getItem('compare-products') || '[]'
    );

    if (compareProducts.length == 0) {
      return;
    } else {
      this.body.innerHTML = '';

      compareProducts.forEach((productHandle) => {
        fetch(`/products/${productHandle}?section_id=compare_card`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              'text/html'
            );
            const card = html.querySelector('.compare-card');

            if (card) {
              this.body.appendChild(card);
              this.setAttribute('aria-hidden', false);

              card.querySelector('.compare-card__remove').addEventListener('click', this.remove.bind(this));
            }
          });
      });
    }
  }
}

customElements.define('compare-widget', CompareWidget);

class CompareAdd extends HTMLElement {
  constructor() {
    super();

    this.productHandle = this.dataset.productHandle;

    this.widget = document.querySelector('compare-widget');
    this.input = this.querySelector(`input[type='checkbox']`);

    if (this.widget) {
      this.setAttribute('data-loaded', true);
      this.init();
      this.addEventListener('change', this.handleChange.bind(this));
    } else {
      this.remove();
    }
  }

  init() {
    const compareProducts = JSON.parse(
      localStorage.getItem('compare-products') || '[]'
    );

    if (compareProducts.includes(this.productHandle)) {
      this.input.checked = true;
    }
  }

  handleChange() {
    // When checked, add the product to the session storage
    // When unchecked, remove the product from the session storage
    if (this.input.checked) {
      const compareProducts = JSON.parse(
        localStorage.getItem('compare-products') || '[]'
      );

      if (!compareProducts.includes(this.productHandle)) {
        compareProducts.push(this.productHandle);

        if (compareProducts.length > 8) {
          const firstProduct = compareProducts[0];
          const firstProductCheckbox = document.querySelector(
            `compare-add[data-product-handle='${firstProduct}'] input[type='checkbox']`
          );
          firstProductCheckbox.checked = false;

          compareProducts.shift();
        }

        localStorage.setItem(
          'compare-products',
          JSON.stringify(compareProducts)
        );
      }
    } else {
      const compareProducts = JSON.parse(
        localStorage.getItem('compare-products') || '[]'
      );

      const index = compareProducts.indexOf(this.productHandle);
      if (index > -1) {
        compareProducts.splice(index, 1);
        localStorage.setItem(
          'compare-products',
          JSON.stringify(compareProducts)
        );
      }
    }

    this.widget.update();
  }
}

customElements.define('compare-add', CompareAdd);
